<div class="manage-challenges-sidebar">
  <!-- Challenges Section -->
  <div class="manage-challenges-sidebar--section">
    <div class="manage-challenges-sidebar--section-header">
      <h3 class="manage-challenges-sidebar--section-title">Challenges</h3>
    </div>
    <div class="manage-challenges-sidebar--menu">
      <button
        (click)="navigateToTab('overview')"
        class="manage-challenges-sidebar--menu-item"
        [class.active]="isActive(overviewItem)"
        type="button"
      >
        <span class="manage-challenges-sidebar--menu-label">{{ overviewItem.label }}</span>
      </button>
      <div class="manage-challenges-sidebar--menu-group">
        <button
          (click)="toggleSubsections(allChallengesItem)"
          class="manage-challenges-sidebar--menu-item"
          [class.active]="isParentActive(allChallengesItem)"
          [class.has-subsections]="true"
          [class.expanded]="shouldShowSubsections(allChallengesItem)"
          type="button"
        >
        <span class="manage-challenges-sidebar--menu-label">{{ allChallengesItem.label }}</span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          class="manage-challenges-sidebar--menu-arrow"
          [class.expanded]="shouldShowSubsections(allChallengesItem)"
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div
          *ngIf="shouldShowSubsections(allChallengesItem)"
          class="manage-challenges-sidebar--subsections"
        >
          <button
            *ngFor="let subsection of allChallengesItem.subsections"
            (click)="navigateToTab(subsection.tab)"
            class="manage-challenges-sidebar--menu-item subsection"
            [class.active]="isActive(subsection)"
            type="button"
          >
            <span class="manage-challenges-sidebar--menu-label">{{ subsection.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Personalise Section -->
  <div class="manage-challenges-sidebar--section">
    <div class="manage-challenges-sidebar--section-header">
      <h3 class="manage-challenges-sidebar--section-title">Personalise</h3>
    </div>
    <div class="manage-challenges-sidebar--menu">
      <button
        *ngFor="let item of personaliseItems; trackBy: trackByKey"
        (click)="navigateToTab(item.tab)"
        class="manage-challenges-sidebar--menu-item"
        [class.active]="isActive(item)"
        type="button"
      >
        <span class="manage-challenges-sidebar--menu-label">{{ item.label }}</span>
      </button>
    </div>
  </div>
</div>

